import React from 'react';
import { BackArrowDisplayToggle } from './BackArrowDisplayToggle';
import styles from './formsBrowser.module.scss';
import { useTranslation } from 'react-i18next';
import { SearchProps, SelectionProps } from './types/FormTypes';

export const Header = React.memo(
    (props: { selectionProps: SelectionProps; searchProps: SearchProps }) => {
        const { t } = useTranslation();

        try {
            const { selectionProps, searchProps } = props;

            return (
                <div className={styles.headerContainer}>
                    <BackArrowDisplayToggle
                        selectionProps={selectionProps}
                        searchProps={searchProps}
                    />
                    <div className={styles.headerTextContainer}>
                        <h1>{t('FormsBrowser.Header')}</h1>
                    </div>
                </div>
            );
        } catch {
            return null;
        }
    },
);
